import React, { ReactElement, FunctionComponent, memo, useEffect } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../utils/PropTypesDefinitions'
import { TintColor } from '../../BaseComponents/Image/ImageInterfaces'
import CaptionFont from '../../Theme/Fonts/Caption'
import { logComponentDeprecation } from '../../utils/Deprecation'
import BasicCardHeadline from '../HelperClass/BasicCardHeadline'

export type CardHeadlineWithLinkProps = {
    /** title of the card */
    text: string
    /** text shown on the right side */
    hint?: string
    /**
     * function that will be called when the headline is clicked
     *
     * @TJS-type function
     */
    onPress: () => void
    /** colors the corresponding image in black or white */
    tintColor?: TintColor
    /**decide between PlayerImage circled and default image with square shape */
    imageType?: 'DEFAULT' | 'PLAYER'
    /**to display an image on the left from the headline */
    imageUrl?: string
} & TestID

const CardHeadlineWithLink: FunctionComponent<CardHeadlineWithLinkProps> = ({
    text,
    hint,
    onPress,
    tintColor,
    testID,
    imageType = 'DEFAULT',
    imageUrl,
}): ReactElement => {
    /* istanbul ignore next */
    useEffect((): void => {
        logComponentDeprecation('CardHeadlineWithLink')
    }, [])
    return (
        <Touchable onPress={onPress} testID={testID}>
            <Grid noExpand horizontal centerVertical backgroundColor="pearl">
                <BasicCardHeadline imageUrl={imageUrl} imageType={imageType} text={text} />
                <>
                    {hint ? (
                        <Grid horizontal centerVertical overflow="hidden" alignRight marginLeft={4}>
                            <Grid noExpand minWidth={0}>
                                <CaptionFont numberOfLines={1}>{hint}</CaptionFont>
                            </Grid>
                        </Grid>
                    ) : null}
                    <Grid horizontal noExpand={!!hint} centerVertical marginLeft={4} alignRight>
                        <FontelloIcon
                            textAlign="right"
                            name="scroll-right"
                            fontSize={15}
                            color={tintColor === 'white' ? 'WHITE' : undefined}
                        />
                    </Grid>
                </>
            </Grid>
        </Touchable>
    )
}

export default memo(CardHeadlineWithLink)
